import { connect } from 'react-redux';
import { change } from 'redux-form';
import CreateOrder from '../components/create-order';
import {
  answer,
  createOrder,
  initializeOrder,
  resetError,
  setDefaults,
  setIndicatorDefaults,
  toggleIndicatorWizard,
} from './create-order-actions';
import {
  getBusinessSubTypes,
  getCostPaidBys,
  getDescriptionField,
  getDescriptions,
  getDynamicValue,
  getFilteredIndicatorTypes,
  getFilteredOrderTypes,
  getIndicatorBusinessSubTypes,
  getIndicatorDescription,
  getIndicatorInputs,
  getIndicators,
  getOrderTypeField,
  getPaidByValues,
  getPaidByWizardInputs,
  getScheduledItems,
  getSplitInvoice,
  getSplitInvoiceIndicator,
  hasValues,
} from './create-order-selectors';

const mapStateToProps = state => ({
  orderTypes: getFilteredOrderTypes(state),
  descriptions: getDescriptions(state),
  costPaidBys: getCostPaidBys(state),
  paidByValues: getPaidByValues(state),
  indicators: getIndicators(state),
  indicatorTypes: getFilteredIndicatorTypes(state),
  indicatorInputs: getIndicatorInputs(state),
  wizardInputs: getPaidByWizardInputs(state),
  dynamicValue: getDynamicValue(state),
  description: getDescriptionField(state),
  splitInvoiceIndicator: getSplitInvoiceIndicator(state),
  splitInvoice: getSplitInvoice(state),
  orderType: getOrderTypeField(state),
  shouldRenderIndicatorDescription: getIndicatorDescription(state),
  navContext: state.order.create.navContext,
  scheduledItems: getScheduledItems(state),
  isLoading: state.order.create.isLoadingOrder,
  orderTypeHasValues: hasValues(state),
  machineIsRunning: state.order.create.machineIsRunning,
  redirectUrl: state.order.create.redirectUrl,
  contextId: state.order.create.orderId,
  error: state.order.create.error,
  isSubmitting: state.order.create.isSubmitting,
  useIndicatorWizard: state.order.create.useIndicatorWizard,
  directSelectionOnly: state.order.create.directSelectionOnly,
  serviceTypes: state.order.create.serviceTypes,
  businessSubTypes: getBusinessSubTypes(state),
  indicatorBusinessSubTypes: getIndicatorBusinessSubTypes(state),
  wizardType: state.order.create.wizardType,
  isFiscalCodeServiceCenter: state.order.create.isFiscalCodeServiceCenter,
});

const mapDispatchToProps = {
  initializeOrder,
  answer,
  createOrder,
  change,
  setDefaults,
  setIndicatorDefaults,
  toggleIndicatorWizard,
  resetError,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateOrder);
